module.exports = __webpack_public_path__ + "static/media/solentLogo.9b9dc7ba.jpg";